import { Injectable } from '@angular/core';
import { BaseHttpService, Query, UriBuilderParams } from './base/base-http.service';
import { HttpServiceBundle } from './base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { BaseWithIdList } from '../../shared/models/list';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { ClaimNetChannelEnum, ClaimNetChannels, RecipientOptions } from '@app/shared/models/recipient-options';
import { map } from 'rxjs/operators';
import { ClientService } from '@app/core/services/client.service';
import { ClientCategoryEnum } from '@app/shared/models/client-category';


export class RecipientOptionsUriBuilderParams extends UriBuilderParams<RecipientOptions> {

    constructor(base?: RecipientOptions | string) {
        super(base);
    }

    public buildUri(): string {
        return this.simpleUriBuild(`${BackendUriUnits.CLIENTS}/${BackendUriUnits.DISTRIBUTION_OPTION}`);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RecipientOptionsService extends BaseHttpService<RecipientOptions, RecipientOptionsUriBuilderParams>
                                     implements Query<RecipientOptions, RecipientOptionsUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle, protected clientService: ClientService) {
        super(RecipientOptions, httpServiceBundle, true);
    }

    public query(uriParams: RecipientOptionsUriBuilderParams): Observable<BaseWithIdList<RecipientOptions>> {
        return this.queryBase(uriParams)
                   .pipe(map(result => BaseWithIdList.upgradeFromBaseList(result)));
    }

    public getById(uriParams: RecipientOptionsUriBuilderParams): Observable<RecipientOptions> {
        return this.getBaseById(uriParams);
    }

    public create(uriParams: RecipientOptionsUriBuilderParams, toCreate: RecipientOptions): Observable<RecipientOptions> {
        return this.createBase(uriParams, toCreate);
    }

    public update(uriParams: RecipientOptionsUriBuilderParams, toUpdate: RecipientOptions): Observable<RecipientOptions> {
        return this.updateBase(uriParams, toUpdate);
    }

    public delete(uriParams: RecipientOptionsUriBuilderParams): Observable<boolean> {
        return this.deleteBase(uriParams);
    }


    // VARIA METHODS *****************************************************************************************

    public getClaimNetChannelsAsTranslationEntries(): Observable<any> {
        return this.clientService.getCategories(ClientCategoryEnum.CLAIMNET)
                                 .pipe(map(result => result.services.map(service => ClaimNetChannels.getByKey(service.name as ClaimNetChannelEnum))));
    }
}
